import React from 'react'
import { LoadingContainer } from '@src/screens/Common/containers/LoadingContainer'

export const ProductsLoading = () => {
  return <LoadingContainer />
}
